import { fromJS, Map as IMap } from 'immutable';

import isEmptyRule from '../validate/isEmpty';
import validateFieldsByRules from '../validate/ruleValidator';
import { giftCardFieldNames } from '../item/newItemForm';
import itemMessages from '../item/itemMessages';


const validate = (values, props) => {
    const { intl } = props;
    const isSelfBuy = values.get('isSelfBuy');
    let constraints = IMap();
    if (!isSelfBuy) {
        constraints = constraints.merge(fromJS({
            [giftCardFieldNames.RECIPIENT_NAME_FIELD]: [isEmptyRule(itemMessages.recipientNameInvalid)],
            [giftCardFieldNames.SENDER_NAME_FIELD]: [isEmptyRule(itemMessages.senderNameInvalid)]
        }));
    }
    return validateFieldsByRules(values, constraints, intl);
};

export default validate;
